import { render, staticRenderFns } from "./HeaderPublic.vue?vue&type=template&id=b23cfa72&scoped=true"
import script from "./HeaderPublic.vue?vue&type=script&lang=js"
export * from "./HeaderPublic.vue?vue&type=script&lang=js"
import style0 from "./HeaderPublic.vue?vue&type=style&index=0&id=b23cfa72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23cfa72",
  null
  
)

export default component.exports